export const getPriceVisibility = (priceVisibility: string) =>
  priceVisibility === 'hidden';
